import {
  BlackLogo,
  expandIcon,
  expandIconClosed,
  JMLogo,
} from "@/constant/imagePath";
import { cn } from "@/utils/cn";
import React, { useState } from "react";
import SidebarItems from "./SidebarItems";

export default function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div
      className={cn(
        "gap-y-2 flex py-1 flex-col overflow-hidden bg-white h-full transition-all duration-300",
        sidebarOpen ? "w-[250px]" : "w-[64px]"
      )}
    >
      <div className={cn("w-full flex flex-col")}>
        <div
          className={cn(
            "flex-1 w-full flex",
            sidebarOpen ? "justify-end" : "justify-center"
          )}
        >
          <button
            onClick={toggleSidebar}
            className={cn(
              " hover:bg-gray-100 transition-all duration-300 rounded-md",
              sidebarOpen ? "mr-2" : "mr-0"
            )}
          >
            <img
              src={expandIconClosed}
              className={cn(
                "transition-all duration-300",
                !sidebarOpen ? "rotate-180" : "rotate-0"
              )}
              alt="toggle sidebar"
            />
          </button>
        </div>
        <div className="h-16 flex items-center">
          <div className="w-full flex items-center justify-center">
            <img
              src={sidebarOpen ? BlackLogo : JMLogo}
              alt="logo"
              className={cn(
                "transition-all duration-300",
                sidebarOpen ? "w-32 h-12" : "w-10 h-5"
              )}
            />
          </div>
        </div>
      </div>

      <SidebarItems sidebarOpen={sidebarOpen} />
    </div>
  );
}
